import { render } from "./zhichi.vue?vue&type=template&id=403230a8"
import script from "./zhichi.vue?vue&type=script&lang=js"
export * from "./zhichi.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__